import React, {useEffect, useState} from "react";
import styles from "./ListItem.module.css";
import {AppApi} from "../AppApi";
import {ProgressSpinner} from "primereact/progressspinner";

export default function ListItem(props) {

    const [trip, setTrip] = useState(null);
    const [image, setImage] = useState(null);

    useEffect(() => {
        setTrip(props.trip)
        loadImage(props.trip.extension?.images[0].id)

    }, [props.trip]);

    function loadImage(id) {
        AppApi.pub.getTripImages(id)
            .then(response => {
                setImage(URL.createObjectURL(response.data));

            })
            .catch(console.log)
    }

    if(trip){
        return (
            <div
                className={styles.trip}
                style={{maxWidth: '340px', cursor: 'pointer'}}
                onClick={
                    () => props.onClick && props.onClick(trip)}>
                <div style={{boxShadow: '5px 5px 25px rgb(0 0 0 / 30%)', borderRadius: '1rem',}}>
                    <div className="flex flex-column align-items-end ">
                        {image == null && (
                            <div style={{minWidth: '320px', minHeight: '240px', borderRadius: '1rem', background: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                <ProgressSpinner />
                            </div>
                        )}
                        <div>
                            {image != null && (
                                <img style={{width: '100%', borderRadius: '1rem'}} src={image} alt={ trip.extension?.images[0].filename} />
                            )}
                        </div>
                        <div style={{background: '#FFFFFF', position: 'absolute', padding: '2px', margin: '10px', fontWeight: 'bold'}}>{trip.appointmentLength} Tage</div>
                    </div>
                    <div style={{height: 3}}></div>
                    <div style={{background: '#FFFFFF', borderBottomLeftRadius: '1rem', borderBottomRightRadius: '1rem', marginTop: -15, padding: '15px 10px 5px 10px'}}>
                        <div className={styles.nameTextClamp+ " text-1xl font-bold"} >{trip.name}</div>
                        <div style={{fontSize: 'var(--font-size-1)'}}>
                            <table>
                                <tbody>
                                <tr>
                                    <td style={{width: '100%'}}>

                                        <div className={styles.locationTextClamp}>
                                            {trip.location}
                                        </div>
                                        {trip.appointmentDate && (
                                            <div>
                                                <i style={{color: '#01d997'}} className="pi pi-calendar"></i> Ihr Termin: {trip.appointmentDate}
                                            </div>
                                        )}
                                        {!trip.appointmentDate && (
                                            <div>
                                                <i style={{color: '#01d997'}} className="pi pi-calendar"></i> Nächster Start: {trip.extension.relevantAppointments[0]?.date}
                                            </div>
                                        )}
                                    </td>
                                    <td style={{whiteSpace: 'nowrap'}}>
                                        <div>
                                            <span className="pl-2 text-2xl font-semibold">{trip.price} {trip.currency}</span><br/>
                                            <span style={{fontSize: 8, float: 'right'}}>pro Teilnehmer</span>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div style={{height: 3}}></div>
                        {trip.extension.recognizedStates?.map( recognizedState => (
                            <div style={{display:'inline-block', textAlign: 'center', fontSize: 10, width: '19px', padding: 1, margin: 2, background: '#c3f3ff', borderRadius: 3}}>{recognizedState.code}</div>
                        ))}
                    </div>
                </div>
            </div>
        )
    } else {
        return <div></div>
    }

}